<template>
    <div class="c-yn" :style="wrapStyle">
        <div :style="innerStyle">
            <div :style="headerStyle">
                <div :style="eyebrowStyle">{{ agencyName }}</div>
                <h1 :style="h1Style">Do you have another service?</h1>
                <p :style="leadStyle">
                    Tell us whether there's another service on this deal you'd
                    like to record.
                </p>
            </div>

            <CCard :extra-style="cardStyle">
                <div :style="choicePairStyle">
                    <CChoice
                        icon="✓"
                        label="Yes, there is"
                        sub="I'll add another upsell"
                        tone="green"
                        :selected="isHasNewService === true"
                        @click="isHasNewService = true"
                    />
                    <CChoice
                        icon="–"
                        label="No, that's all"
                        sub="Move on to the next step"
                        tone="neutral"
                        :selected="isHasNewService === false"
                        @click="isHasNewService = false"
                    />
                </div>
            </CCard>

            <div :style="navStyle">
                <CBtn ghost @click="() => onChangeSection(SECTIONS.UPSELL, SECTIONS.DO_YOU_HAVE_SERVICE)">
                    ← Previous
                </CBtn>
                <CBtn primary big @click="onNextPage">Next →</CBtn>
            </div>
        </div>
    </div>
</template>

<script>
import { scrollToTop } from "../../../helpers/_scrollToTop";
import { SECTIONS } from "../consts";

import CCard from "../c-design/CCard.vue";
import CChoice from "../c-design/CChoice.vue";
import CBtn from "../c-design/CBtn.vue";
import viewportMixin from "../c-design/useViewport";
import { C_BG, C_INK, C_MUTED, C_HAIR, FONT_DISPLAY, navMobileStickyStyle } from "../c-design/tokens";

export default {
    name: "Wizard_Do_You_Have_New_Service",
    mixins: [viewportMixin],
    components: { CCard, CChoice, CBtn },
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isHasNewService: null,
        };
    },

    mounted() {
        scrollToTop();
    },

    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        upsellIndex() {
            return this.$store.getters.getCurrentIndexUpsell;
        },
        // ===== c-design style maps =====
        wrapStyle() {
            return {
                background: C_BG,
                minHeight: '70vh',
                padding: this.isMobile ? '14px 12px 110px' : '24px 16px 40px',
            };
        },
        innerStyle() {
            return { maxWidth: '780px', margin: '0 auto' };
        },
        headerStyle() {
            return {
                marginBottom: this.isMobile ? '16px' : '24px',
                padding: this.isMobile ? '0 4px' : '0 8px',
            };
        },
        eyebrowStyle() {
            return {
                fontSize: '12px', color: C_MUTED, letterSpacing: '0.6px',
                textTransform: 'uppercase', fontWeight: 600,
            };
        },
        h1Style() {
            return {
                margin: '6px 0 8px', fontFamily: FONT_DISPLAY,
                fontSize: this.isMobile ? '26px' : '34px',
                fontWeight: 700,
                letterSpacing: this.isMobile ? '-0.7px' : '-1px',
                lineHeight: 1.1, color: C_INK,
            };
        },
        leadStyle() {
            return {
                margin: 0,
                fontSize: this.isMobile ? '13.5px' : '15px',
                color: C_MUTED,
                lineHeight: 1.55,
            };
        },
        cardStyle() {
            return {
                marginBottom: this.isMobile ? '14px' : '18px',
                padding: this.isMobile ? '22px' : '32px 36px',
            };
        },
        choicePairStyle() {
            return {
                display: 'grid',
                gridTemplateColumns: this.isMobile ? '1fr' : '1fr 1fr',
                gap: this.isMobile ? '10px' : '12px',
            };
        },
        navStyle() {
            return navMobileStickyStyle(this.isMobile, {
                marginTop: '8px', padding: '16px 24px',
                background: '#fff', borderRadius: '16px',
                border: `1px solid ${C_HAIR}`,
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', gap: '16px',
            });
        },
    },

    methods: {
        onNextPage() {
            if (
                this.isHasNewService === undefined ||
                this.isHasNewService === null
            ) {
                this.$toast.error("Please select an answer");
                return;
            }

            if (this.isHasNewService) {
                this.onChangeSection(
                    SECTIONS.UPSELL,
                    SECTIONS.DO_YOU_HAVE_SERVICE
                );
                this.$store.commit("setIndexUpsell", this.upsellIndex + 1);
                return;
            }

            this.onChangeSection(
                SECTIONS.DO_YOU_HAVE_UPSELL,
                SECTIONS.DO_YOU_HAVE_SERVICE
            );
        },
    },
};
</script>
